<template>
    <div class="card">
        <div class="card-header pb-0">
            <div class="row align-top">
                <div class="col-md-2">
                    <h6>Clientes</h6>
                </div>
                <div class="col-md-8">
                    <div class="input-group">
                        <span class="input-group-text text-body">
                            <i class="fas fa-search" aria-hidden="true"></i>
                        </span>
                        <input
                            type="text"
                            class="form-control"
                            v-model="searchTerm"
                            :placeholder="
                                this.$store.state.isRTL ? 'أكتب هنا...' : 'Buscar...'
                            "
                        />
                </div>
                </div>
                <div class="col-md-2 ">
                        <argon-button
                        class="mt-0"
                        color="info"
                        fullWidth
                        size="xs"
                        @click="toCreate"
                        >Agregar Nuevo</argon-button> 
                </div> 
            </div>
        </div>
        <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                    <thead>
                        <tr>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Código
                            </th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Nombre
                            </th>
                            <th
                                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                            >
                                NIT
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Tipo
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Email
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Teléfono
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Dirección Fiscal
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Dirección Comercial
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Fecha Creación
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Acciones
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr 
                            v-for="(
                                {
                                    id,
                                    nit,
                                    name,
                                    business_name,
                                    email,
                                    phone,
                                    fiscal_address,
                                    commercial_address,
                                    type,
                                    created_at
                                },
                                index
                            ) in filteredRows"
                            :key="index"
                        > 
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="mb-0 text-sm">{{ id }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="mb-0 text-sm">
                                            {{ business_name || name }}
                                        </h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ nit }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">
                                    {{ type === 'NATURAL' ? 'Natural' : 'Jurídica' }}
                                </p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ email }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ phone }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ fiscal_address }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ commercial_address }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ created_at }}</p>
                            </td>
                            <td class="align-middle">
                                <a
                                    :href="'view-client/' + id"
                                    class="btn bg-success mx-2"
                                    data-toggle="tooltip"
                                    data-original-title="Ver cliente"
                                >
                                    <i class="fa fa-eye text-white text-sm opacity-10"></i>
                                </a>
                                <a
                                    :href="'edit-client/' + id"
                                    class="btn bg-primary mx-2"
                                    data-toggle="tooltip"
                                    data-original-title="Editar cliente"
                                >
                                    <i class="fa fa-edit text-white text-sm opacity-10"></i>
                                </a>
                                <!-- Puedes agregar más acciones si es necesario, ej. eliminar -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";

export default {
    name: "clients-table",
    props: {
        clients: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            searchTerm: null
        };
    },
    components: { ArgonButton},
    computed: {
        filteredRows() {
            if (!this.searchTerm) {
                return this.clients;
            } else {
                const searchLower = this.searchTerm.toLowerCase();
                return this.clients.filter(client => {
                    const clientName = (client.name || client.business_name || '').toString().toLowerCase();
                    const nit = client.nit.toString().toLowerCase();
                    const email = client.email.toString().toLowerCase();
                    const phone = client.phone.toString().toLowerCase();
                    const type = client.type.toString().toLowerCase();
                    return clientName.includes(searchLower) || 
                           nit.includes(searchLower) || 
                           email.includes(searchLower) ||
                           phone.includes(searchLower) ||
                           type.includes(searchLower);
                });
            }
        }
    },
    methods: {
        toCreate() {
            this.$router.push('/create-client');
        },
    },
};
</script>